module.exports = __webpack_public_path__ + "media/images/icons/outstanding_applicant-31741174c574a900c98c2c5b5374a8a8.svg";